import { APP_TYPE } from '../constants/App';

const tokenName = 'x-seller-token';
const headers = () => {
  const xToken = localStorage.getItem(tokenName);
  return {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'token': xToken
  }
};

const corsHeaders = () => {
  return {
    'Accept': 'application/xml'
  }
};

const getToken = () => {
  return localStorage.getItem(tokenName);
}
const isValidToken = () => {
  const xToken = getToken();
  if (!xToken) {
    const originalUrl = document.location.pathname;
    //window.location.href = `/?originalUrl=${originalUrl}`;
  }
  return !!xToken;
}

const defaultResponse = async (res, isLoginRequired) => {
  const status = res.status;
  res = await res.json();
  if (status === 403 && isLoginRequired) {
    localStorage.removeItem(tokenName);
    const originalUrl = document.location.pathname;
    window.location.href = `/?originalUrl=${originalUrl}`;
    return { resStatus: status, message: 'Your token has expired, please login again.' }
  }
  if (status >= 400) {
    const message = res.message;
    return { resStatus: status, ...res }
  }
  return { ...res, resStatus: status }
}

const get = (api, isLoginRequired = true) => {
  if (isLoginRequired && !isValidToken()) {
    return null;
  }
  return fetch(api, {
    headers: headers(),
    credentials: 'include',
    method: 'GET'
  })
    .then((res) => defaultResponse(res, isLoginRequired));
};

const post = (api, data, isLoginRequired = true) => {
  if (isLoginRequired && !isValidToken()) {
    return null;
  }
  return fetch(api, {
    headers: headers(),
    credentials: 'include',
    method: 'POST',
    body: JSON.stringify(data)
  })
    .then((res) => defaultResponse(res, isLoginRequired));
};

const put = (api, data, isLoginRequired = true) => {
  if (isLoginRequired && !isValidToken()) {
    return null;
  }
  return fetch(api, {
    headers: headers(),
    credentials: 'include',
    method: 'PUT',
    body: JSON.stringify(data)
  })
    .then((res) => defaultResponse(res, isLoginRequired));
};

const destroy = (api, isLoginRequired = true) => {
  if (isLoginRequired && !isValidToken()) {
    return null;
  }
  return fetch(api, {
    headers: headers(),
    credentials: 'include',
    method: 'DELETE'
  })
    .then((res) => defaultResponse(res, isLoginRequired));
};

const toggle = (api, isLoginRequired = true) => {
  if (isLoginRequired && !isValidToken()) {
    return null;
  }
  return fetch(api, {
    headers: headers(),
    credentials: 'include',
    method: 'PUT'
  })
    .then((res) => defaultResponse(res, isLoginRequired));
};

const login = (loginCredentials) => {
  return fetch('/api/login', {
    headers: { ...headers()},
    credentials: 'include',
    method: 'POST',
    body: JSON.stringify(loginCredentials)
  })
    .then((res) => defaultResponse(res))
    .then((res) => {
      if (res.resStatus == 200) {
        const { token } = res.data;
        localStorage.setItem(tokenName, token);
      }
      return res;
    });
}

const loginWithToken = (token) => {
  return fetch('/api/login/onetime', {
    headers: { ...headers() },
    credentials: 'include',
    method: 'POST',
    body: JSON.stringify(token)
  })
    .then((res) => defaultResponse(res))
    .then((res) => {
      if (res.resStatus == 200) {
        const { token } = res.data;
        localStorage.setItem(tokenName, token);
      }
      return res;
    });
}

const logout = async (redirect=true) => {
  await get('/api/logout');
  localStorage.removeItem(tokenName);
  if(redirect)
  {
    window.location.href = '/';
  }
}

const postCrossOriginFormData = (api, data) => {

  return fetch(api, {
    headers: corsHeaders(),
    method: 'POST',
    body: data
  })
    .then((res) => {
      //return defaultResponse(res, isLoginRequired);
    });
}

const postFormData = (api, data, isLoginRequired = true) => {
  if (isLoginRequired && !isValidToken()) {
    return null;
  }
  return fetch(api, {
    headers: formHeaders(),
    credentials: 'include',
    method: 'POST',
    body: data
  })
    .then((res) => defaultResponse(res, isLoginRequired));
};

const formHeaders = () => {
  const xToken = localStorage.getItem(tokenName);
  return {
    'Accept': 'application/json',
    //'Content-Type': 'multipart/form-data; boundary=XXX',
    'token': xToken
    
  }
};

export {
  headers,
  get,
  post,
  put,
  destroy,
  toggle,
  login,
  loginWithToken,
  logout,
  getToken,
  postCrossOriginFormData,
  postFormData,
  formHeaders
};